export default "__VITE_PUBLIC_ASSET__87f0e0c6__"